const Template = {
  render: function (template, data) {
    // Handle blocks like {{#description}}...{{/description}}
    template = template.replace(/{{#\s*(\w+)\s*}}([\s\S]*?){{\/\s*\1\s*}}/g, (_, key, inner) => {
      const list = data[key];
      if (!Array.isArray(list)) return "";
      return list.map(item => inner.replace(/{{\s*\.?\s*}}/g, item)).join("");
    });

    // Handle single keys like {{url}}, {{label}}, etc.
    return template.replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
      return (key in data) ? data[key] : "";
    });
  }
};
